import map from 'lodash/map';
import { getAllResultStateInfos, getFilters, getGroups, getGroupStates, getFilterOrder, getParentSubview, getSearchFilterByModelId} from "~/stateGetter";
import { presentAppliedFilterOrder, presentFilters, presentGroups, presentAppliedFilterValues } from "~/statePresenter";
import {connect} from "~/redux/connect";
import toOrderedArray from "~/lib/toOrderedArray";
import {compareKeys} from "mythil/object";
import keys from "lodash/keys";
import keyBy from "lodash/keyBy";
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import size from 'lodash/size';

const areStatePropsEqual = (prev, curr) => {
    return compareKeys(prev, curr, (prev, curr, key) => {
        switch (key) {
            case "appliedFilters":
            case "appliedFiltersOrder":
                return isEqual(prev, curr);
            default: return prev === curr;
        }
    })
}

export const connectedFilterFields = ({ withAllFilters = false, withSearchFilter = true } = {}) => connect(
    (state, { modelId }) => {
        const getAppliedFilters = (modelStateInfo) => presentAppliedFilterValues({...modelStateInfo, parentItemId: null, filters, modelSearchFilter, takeAllCreatedFilters: !withAllFilters }),
              modelStateInfo = getAllResultStateInfos(state, modelId),
              filters = keyBy(presentFilters(modelStateInfo), "name"),
              modelSearchFilter = getSearchFilterByModelId(state, modelId),
              appliedFilters = getAppliedFilters(),
              appliedFiltersOrder = presentAppliedFilterOrder({...modelStateInfo, parentItemId: null, filterOrder: getFilterOrder(state, modelId), });

        return {
            groups: getGroups(state, modelId),
            groupStates: getGroupStates(state, modelId),
            filters: getFilters(state, modelId),
            appliedFilters: withAllFilters ? null : keys(appliedFilters),
            appliedFilterCount: size(presentAppliedFilterValues({ ...modelStateInfo, parentItemId: null, filters, })),
            appliedFiltersOrder,
            modelSearchFilter,
            ...getParentSubview(state, modelId),
        }
    },
    (dispatch) => ({}),
    (props, dispatchProps, ownProps) => {
        let {  groups, appliedFilters, appliedFilterCount, appliedFiltersOrder, groupStates, modelSearchFilter, filters, parentSubview, initialFilterValues, filterValues, ...other } = props;

        if (!withSearchFilter) {
            filters = omit(filters, modelSearchFilter);
        }

        let presentedGroups = toOrderedArray(presentGroups({
                parentSubview,
                groups,
                groupStates,
                filters,
                onlyOpen: true,
            })),
            // captions = presentedGroups.reduce((groupCaptions, group) => {
            //     groupCaptions[group.name] = group.title
            //     return groupCaptions;
            // }, {}),

            filterNames = presentedGroups.reduce((names, group) => {
                return [...names, ...map(group.filters, filter => {
                    const appliedIndex = appliedFiltersOrder?.indexOf(filter.name);

                    return {
                        name: filter.name,
                        group: filter.group,
                        builder_order: appliedIndex >= 0 ? appliedIndex : 1000 //get(props.filterOrder, filter.name) || filter.builder_order + 1 || filter.order + 1 || index + 1,
                    }
                })]
            }, []);


        return {
            ...ownProps,
            ...other,
            ...dispatchProps,
            captions: {},
            appliedFilterCount,
            filterNames: toOrderedArray(filterNames)
                .filter(({name}) => appliedFilters?.includes(name) ?? true),
        }
    },
    { areStatePropsEqual }
)